export default {
    data: () => ({
        translations: {
            title: {
                el: "Εμφάνιση Προγράμματος Επιβράβευσης",
                en: "Show Loyalty Program",
                it: "Mostra Programma Fedeltà"
            },
            info: {
                el: "Εμφάνιση του προγράμματος επιβράβευσης στην εφαρμογή RoadCube;",
                en:
                    "Show loyalty program in RoadCube app?",
                it: "Mostra il programma fedeltà nell'app RoadCube?"
            },
            yes: {
                el: "Ναι",
                en: "Yes",
                it: "Sì"
            },
            no: {
                el: "Όχι",
                en: "No",
                it: "No"
            }
        }
    })
};
